// extracted by mini-css-extract-plugin
export var bubble = "_29-0";
export var container = "_29-f";
export var contrastBorder = "_29-g";
export var greyOut = "_29-2";
export var initialsColor0 = "_29-3";
export var initialsColor1 = "_29-4";
export var initialsColor10 = "_29-d";
export var initialsColor11 = "_29-e";
export var initialsColor2 = "_29-5";
export var initialsColor3 = "_29-6";
export var initialsColor4 = "_29-7";
export var initialsColor5 = "_29-8";
export var initialsColor6 = "_29-9";
export var initialsColor7 = "_29-a";
export var initialsColor8 = "_29-b";
export var initialsColor9 = "_29-c";
export var initialsWrapper = "_29-1";
export var large = "_29-l";
export var medium = "_29-k";
export var mediumSmall = "_29-j";
export var mediumSmallMedium = "_29-o";
export var micro = "_29-h";
export var small = "_29-i";
export var tiny = "_29-n";
export var xTiny = "_29-m";